<template>
	<div class="product-list">
		<div class="product-list-header">
      <div>
        <span class="header-title">{{ title }}</span>
      </div>
		</div>
		<div class="product-list-body">
			<index-product-body
				:item="item"
				:index="index"
				v-for="(item, index) in items"
				v-bind:key="index"
			></index-product-body>
		</div>
	</div>
</template>

<script>
import IndexProductBody from './IndexProductBody'

export default {
  name: 'IndexProductList',
  data () {
    return {}
  },
  props: ['items', 'title', 'type'],
  components: {
    IndexProductBody
  },
  computed: {

  }
}
</script>

<style lang="scss" scoped>
.product-list {
	background: #ffffff;
	margin-top:0.45rem;
	margin-bottom:0.45rem;
	.product-list-header {
		display: flex;
		min-height:2.45rem;
		padding: 0.4rem 0.55rem;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid #f5f5f5;
    box-sizing: border-box;
		.header-title {
      display: block;
			font-size:0.76rem;
			color: #17202a;
			font-weight:700;
      line-height: 1rem;
		}
	}
	.product-list-body {
		display: flex;
		flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
    padding: 3.2vw;
    background-color: #fff;
	}
}
</style>
